import React, { useEffect } from 'react'
import Header from '../../components/global/Header'
import styles from "../../asset/css/nextToken.module.css";
import { ImageComponent } from '../../components/global/ThemeImg';
export default function NexusTokenPage() {
    return (
        <div className={`${styles.nexusTokenPage} homePagelayout`}>
            <Header />
            <div className={styles.pageContentPart}>
                <section className={styles.bannerSection}>
                    <div className={styles.leftPart}>
                        <h3>$NXUS</h3>
                        <h4>Nexus $NXUS Token:</h4>
                        <p>
                            The $NXUS token is the native utility and governance token of Nexus Launchpad, designed to empower fair launches, incentivize participation, and support the long-term growth of high-quality projects on Solana.
                        </p>
                    </div>
                    <div className={styles.rightPart}>
                        <ImageComponent staticImgSrc={"rocketImg"} />
                    </div>
                </section>
                <section className={styles.nexusTokenomicSection}>
                    <div className={styles.leftContentPart}>
                        <div className={styles.topText}>
                            <ImageComponent staticImgSrc={"nexusTokenIcon1"} />
                            <div>
                                <h2>Total Supply</h2>
                                <p>1,000,000,000</p>
                            </div>
                        </div>
                        <div className={styles.bottomText}>
                            <p>
                                Fair Launch Model on Pump.Fun - No VC/insider allocations, ensuring a truly decentralized launch.
                            </p>
                        </div>
                    </div>
                    <div className={styles.centerLogoPart}>
                        <ImageComponent staticImgSrc={"nexusTokenCenterLogo"} />
                        <p>
                            These tokens will be available for sale in the Pump.Fun bonding curve, and later on upon it bonding on Raydium. We will be open  sourcing the entire project at $20m marketcap.
                        </p>
                    </div>
                    <div className={styles.rightContentPart}>
                        <div className={styles.topText}>
                            <ImageComponent staticImgSrc={"nexusTokenIcon2"} />
                            <div>
                                <h2>Circulating Supply</h2>
                                <p>1,000,000,000</p>
                            </div>
                        </div>
                        <div className={styles.bottomText}>
                            <p>
                                Dev wallet will be purchasing 1.3 Sol worth at time of mint. This should equate to ~4.5%
                                to be the team's allocation.
                                The rest of the tokens, roughly 95% will to be the team's public, or liquidity pool as per pump.fun
                            </p>
                        </div>
                    </div>
                </section>
                <section className={styles.tokenModelSection}>
                    <div className={styles.keyAspectCardPart}>
                        <div className={styles.cardHeader}>
                            <h3>Token Model:</h3>
                            <p>Revenue Sharing Model:
                                <strong> (Coming Soon)</strong> </p>
                        </div>
                        <div className={styles.cardBody}>
                            <p>
                                Stake your NXUS tokens to receive a proportional share of all platform fees generated
                                on the Nexus platform. Receive USDC from fees on your staked NXUS tokens.
                            </p>
                        </div>
                    </div>
                </section>
                <section className={styles.tokenUtilitySection}>
                    <div className={styles.titlePart}>
                        <h2>Token Utility & Use Cases:</h2>
                    </div>
                    <div className={styles.tokenUtilityCardWrapper}>
                        <div className={styles.cardContainer}>
                            <div className={styles.cardHeader}>
                                <h2>Launchpad Access & Tiers</h2>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Staking $NXUS unlocks priority access to premium project launches.
                                    </li>
                                    <li>
                                        Higher staking amounts grant better allocations and early investment rights.
                                    </li>
                                    <li>
                                        Fair launch guarantee—no VC advantages, just community-driven allocations.
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.floatIcon}>
                                <ImageComponent staticImgSrc={"whyNexuIcon1"} />
                            </div>
                        </div>
                        <div className={styles.cardContainer}>
                            <div className={styles.cardHeader}>
                                <h2>Staking & Rewards</h2>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Stake $NXUS to earn yield and receive early access to upcoming launches.
                                    </li>
                                    <li>
                                        Stakers share in launchpad revenue from token sales and project fees.
                                    </li>
                                    <li>
                                        Multi-tier staking model: More $NXUS staked = better benefits (higher allocations, exclusive deals).
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.floatIcon}>
                                <ImageComponent staticImgSrc={"tokenomicsIcon3"} />
                            </div>
                        </div>
                        <div className={styles.cardContainer}>
                            <div className={styles.cardHeader}>
                                <h2>Governance & Voting</h2>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        $NXUS holders can vote on key platform
                                        decisions, including :
                                    </li>
                                    <li>
                                        Project listings and quality standards
                                    </li>
                                    <li>
                                        Fee structures and revenue distribution
                                    </li>
                                    <li>
                                        Protocol upgrades and ecosystem initiatives
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.floatIcon}>
                                <ImageComponent staticImgSrc={"tokenomicsIcon1"} />
                            </div>
                        </div>
                        <div className={styles.cardContainer}>
                            <div className={styles.cardHeader}>
                                <h2>Fee Discounts & Boosted Allocations</h2>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Using $NXUS for transactions on Nexus Launchpad grants:
                                    </li>
                                    <li>
                                        Discounted participation fees on token sales
                                    </li>
                                    <li>
                                        Boosted allocations for new project launches
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.floatIcon}>
                                <ImageComponent staticImgSrc={"nexusTokenIcon4"} />
                            </div>
                        </div>
                        <div className={styles.cardContainer}>
                            <div className={styles.cardHeader}>
                                <h2>Launchpad Access & Tiers</h2>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Staking $NXUS unlocks priority access to premium project launches.
                                    </li>
                                    <li>
                                        Higher staking amounts grant better allocations and early investment rights.
                                    </li>
                                    <li>
                                        Fair launch guarantee—no VC advantages, just community-driven allocations.
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.floatIcon}>
                                <ImageComponent staticImgSrc={"nexusTokenIcon3"} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className={styles.nexusTokenBgPatten}>
                {
                    [...Array(9)].map((_, index) => (
                        <ImageComponent moduleStyle={styles} staticImgSrc={`nexusTokenPatten${index + 1}`} moduleClass={`nexusTokenPatten${index + 1}`} />
                    ))
                }
            </div>
        </div>
    )
}
